import instance from "./Request";

export const getClients = async (page = 1, perPage=10, filters = {}) => {
  const request = await instance();
  const cleanFilters = Object.fromEntries(Object.entries(filters || {}).filter(([_, v]) => v !== "" && v !== null && v !== undefined));
  const params = { ...cleanFilters, perPage}
  let data = await request.get(`/users/${page}`, {params}).catch((error) => {
    return {
      error,
    };
  });
  return data;
};

export const changeActive = async (client) => {
  const request = await instance();
  let data = await request
    .post("/clients/block", { customer: client })
    .catch((error) => {
      return {
        error,
      };
    });
  return data;
};

export const getClient = async (user) => {
  const request = await instance();
  let data = await request.get(`/users/profile/${user}`).catch((error) => {
    return {
      error,
    };
  });
  return data;
};

export const getClientOrders = async (user) => {
  const request = await instance();
  let data = await request
    .post("v3/get-orders-history", {
      id_user: user,
      page: 1,
    })
    .catch((error) => {
      return {
        error,
      };
    });
  return data;
};
